// extracted by mini-css-extract-plugin
export var downArrow = "_8t-0";
export var infoTooltipIcon = "_8t-3";
export var label = "_8t-1";
export var optionCard = "_8t-4";
export var upArrow = "_8t-2";